 /*global google*/
 import React, {Component} from 'react';
 import Order from './Order';
 import {Well,Nav,Tab,Tabs,ButtonGroup,Button,FormControl,ControlLabel,FormGroup,Glyphicon,Grid,Col,Row,Modal,Label,Alert} from 'react-bootstrap';
import img1 from '../images/togo.png'
import img2 from '../images/sur_place.png'
import img3 from '../images/livraison.png'
import img4 from '../images/emporter_inactive.png'
import img5 from '../images/sur_place_inactive.png'
import img6 from '../images/livraison_inactive.png'
import maps from '../images/Maps-Pin-Place-icon.png'
import ReactLoading from "react-loading";
import {auth, firebase} from '../firebase';
import {
  withGoogleMap,
  GoogleMap,
  Marker,
  DirectionsRenderer,
  withScriptjs,
} from "react-google-maps" 
import Notification from 'rc-notification';
import 'rc-notification/assets/index.css';

// id dev
//const idRestaurant="-LHCvfvi5Zis0rJffGlg"
// id prod
const idRestaurant="-L8HPl47r9qChaUm_6uU"


let notification = null;
Notification.newInstance({}, (n) => notification = n);

const MapUserLocation =withScriptjs(withGoogleMap(props =>
  <GoogleMap
      defaultZoom={12}
      defaultCenter={{lat:35.821432200973064,lng:10.598030090332031}}
  >
      {props.children}
  

      
       
  </GoogleMap>
));

const defaultPosition = {
  lat: 35.8245,
  lng: 10.6346
};

class Cart extends Component {
  constructor(props){
    super(props);
    this.state={
      selected:0,
      etat:0,
      show:false,
      address: "sousse",
      position: "",
      updated_product:[],
      enabled_product:[],
      name:"",
      phone:"",
      tableN:"",
      order:"",
      showconfirm:false,
      note:"",
      zones:[],
      pos_restaut:[],
      current_pos:{lat:35.821432200973064,lng:10.598030090332031 },
      fee:null,
      delivered_by:null,
      adressa:"",
      permissions:[],
      services:[],
      products:[],
      programme:[],
      alert_out_zone:false,
      notvide:false,
      points : {},
      money_loyalty:0,
      reduce:0,
      new_total:0,
      can_be_delivred:false,
      ordersvgrd:[],
      loading:false
      


    }
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.saveorders_transaction=this.saveorders_transaction.bind(this);


  }
  handleDismiss(){
    this.setState({alert_out_zone:false})
  }
  componentDidMount() {

    var ref_point= firebase.database().ref(`/loyalty_points/`);
    var ref_programme= firebase.database().ref(`/loyalty_program/${this.props.idRestaurant}/`);
   
    let uid
    if(localStorage.getItem('user'))
     uid = JSON.parse(localStorage.getItem('user')).uid;

     if(localStorage.getItem('user'))
    ref_point.orderByChild('user_uid').equalTo(uid)
        .on('child_added',(data)=>{
         // console.log(data.val())
    if(data.val().store_id===idRestaurant)
          this.setState(
            {points:{...data.val(),key:data.key}
        })})
        if(localStorage.getItem('user'))
        ref_point.orderByChild('user_uid').equalTo(uid)
        .on('child_changed',(data)=>{
         // console.log(data.val())
    if(data.val().store_id===idRestaurant)
          this.setState(
            {points:{...data.val(),key:data.key}
        })})
    
        ref_programme.on("value",(data)=>{
          this.setState({programme:data.val(),money_loyalty:(data.val())?data.val().minimum_to_use*100:0})
        })

    // console.log(this.props)  
    var ref = firebase.database().ref(`/products/${this.props.idRestaurant}/`)
    var ref_location = firebase.database().ref(`/stores_locations/${this.props.idRestaurant}/`)
    var ref_zone = firebase.database().ref(`/stores_delivery/${this.props.idRestaurant}/`)

    var ref_permissions=firebase.database().ref(`/stores_permissions/${this.props.idRestaurant}/`) 
    var ref_services=firebase.database().ref(`/stores_services/${this.props.idRestaurant}/`)  
    ref_permissions.on("value",(data)=>{
      this.setState({permissions:data.val()})

    })
    ref_services.on("value",(data)=>{
      this.setState({services:data.val()})
    })

    ref_location.on("value", (data) => {
      

      this.setState({ pos_restaut: data.val().l })


    })

    ref.on("value", (data) => {
     this.setState({products:data.val()})
      let prod
      prod =data.val()

      Object.keys(prod||[]).forEach((v,e)=>{
        this.setState((prevS) => {
          return { updated_product: { ...prevS.updated_product, [v]: prod[v].updated_at }, enabled_product: { ...prevS.enabled_product, [v]: prod[v].available } }
        })

      })
    })
    
    ref_zone.on("value", (data) => {

      this.setState({ zones: data.val() })
    })

    /*
     prof= Object
      .keys(profiles||[])
      .sort((a, b) => profiles[b].name.localeCompare(profiles[a].name))
      .reduce((_sortedObj, key) => ({
        ..._sortedObj, 
        [key]: profiles[key]
      }), {})
    */

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {


        var pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        this.setState({ current_pos: pos })
        // infoWindow.setContent('Location found.');
        // map.setCenter(pos);
        var geocoder = new google.maps.Geocoder
        var latlng = { lat: position.coords.latitude, lng: position.coords.longitude };
        // this.setState({current_pos:latlng})
        geocoder.geocode({ 'location': latlng }, (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              if (results[0].formatted_address.indexOf("Unnamed Road") === 0) {
            
                this.setState({ address: "Unnamed Road, " + results[1].formatted_address })
              }
              else {
                this.setState({ address: results[0].formatted_address })

              }


            } else {
              console.log('No results found');
            }
          } else {
            console.log('Geocoder failed due to: ' + status);
          }
        });

      }, function () {
        // handleLocationError(true, infoWindow, map.getCenter());
        console.log("error")
      });



    } else {
      // Browser doesn't support Geolocation
      console.log("geolocalisation non supporter")
    }


  }


  handleLocationChange ({ position, address }) {
 
    // Set new location
    this.setState({ position, address });
  }


  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }
  genrate_order() {
    var cart = this.props.cart
    var items = cart.items
    var products_count = cart.products_count
    var total_price = cart.total_price
    let items2 = []
    let orders = []
    Object.keys(items || []).forEach((v, e) => {
      items2 = { ...items2, [v]: { ...items[v].variant, updated_at: null, extras: items[v].extras ? items[v].extras : null, quantity: items[v].quantity, options: this.option_correct(items[v].options) } }
    })
    orders = { total_price: total_price, items: items2 }
return orders
  }


  calcul_distance() {
    var current_pos = this.state.current_pos
    var pos_restaut = this.state.pos_restaut
    var from = new google.maps.LatLng(current_pos.lat, current_pos.lng);
    var fromName = 'restaurant';
    var dest = new google.maps.LatLng(pos_restaut[0], pos_restaut[1]);
    var destName = 'client';
this.setState({alert_out_zone:false})
    var service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [from, fromName],
        destinations: [destName, dest],
        travelMode: 'DRIVING'
      }, (response, status) => {
        if (status == 'OK') {
          var origins = response.originAddresses;
          var destinations = response.destinationAddresses;
          var test =this.is_at_zone(response.rows[0].elements[1].distance.value)
if(!test)
{
  this.setState({alert_out_zone:true})
}         
/*  for (var i = 0; i < origins.length; i++) {
                var results = response.rows[i].elements;
                console.log(results);
                for (var j = 0; j < results.length; j++) {
                    var element = results[j];
                    var distance = element.distance.text;
                    var duration = element.duration.text;
                    var from = origins[i];
                    var to = destinations[j];
                }
            }*/
        }
      });
  }
  option_correct(options) {

    var items = []
    Object.keys(options || []).forEach((v, e) => {
      items = { ...items, [v]: { name: options[v].name, element: { ...options[v].elements[Object.keys(options[v].elements)[0]] } } }
    })

    return (items.length > 0) ? items : null
  }
  passer_commande(){
    var user = JSON.parse(localStorage.getItem('user'))
    var orders = this.genrate_order()
    let name = this.state.name
    let phone = this.state.phone
    let tableN = this.state.tableN
    let fee=this.state.fee
    let current_pos=this.state.current_pos
    let adressa=this.state.adressa
    let delivered_by=this.state.delivered_by==='partner'
    //console.log(current_pos)
    if (this.state.selected === 0) {
      //alert("Sélectionnez le type de Livraison")
      notification.notice({
        content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>Sélectionnez le type de Livraison</span>, 
        duration: 5,
        onClose() {
          console.log('closable close');
        },
        closable: true,
      });
    }
    if (this.state.selected === 1) {
      if (name.length > 0 && phone.length > 0) {
        orders = {
          ...orders, status: 'received', order_type: 'togo', user_name: name, user_phone: phone, user_uid: user.uid, created_at: firebase.database.ServerValue.TIMESTAMP, updated_at: firebase.database.ServerValue.TIMESTAMP
        }
        ///
        this.setState({ showconfirm: true, order: orders })
      }
      else {
       // alert('champ(s) vide')
        notification.notice({
          content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>champ(s) vide</span>, 
          duration: 5,
          onClose() {
            console.log('closable close');
          },
          closable: true,
        });
        
      }
    }
    if (this.state.selected === 2) {
      if (name.length > 0 && phone.length > 0 && tableN.length > 0) {
        orders = {
          ...orders, status: 'received', order_type: 'togo', table_number: parseInt(tableN, 10), user_name: name, user_phone: phone, user_uid: user.uid, created_at: firebase.database.ServerValue.TIMESTAMP, updated_at: firebase.database.ServerValue.TIMESTAMP
        }
        ///
        this.setState({ showconfirm: true, order: orders })
      }
      else {
     //   alert('champ(s) vide')
        notification.notice({
          content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>champ(s) vide</span>, 
          duration: 5,
          onClose() {
            console.log('closable close');
          },
          closable: true,
        });
      }
    }
    if (this.state.selected === 3) {
     // console.log(name)
      //console.log(phone)
      //console.log(fee)
      //console.log(delivered_by)
      if (name.length > 0 && phone.length > 0 && fee!==null  ) {
if(this.state.can_be_delivred)
       { orders = {
          ...orders, status: 'received', order_type: 'delivery',is_delegated_to_partner:delivered_by,user_coordinates:current_pos.lat+","+current_pos.lng,user_address:adressa,total_price:fee+this.props.cart.total_price, user_name: name, user_phone: phone, user_uid: user.uid, created_at: firebase.database.ServerValue.TIMESTAMP, updated_at: firebase.database.ServerValue.TIMESTAMP,delivery_fee:fee
        }
        ///
        this.setState({ showconfirm: true, order: orders })}
        else{
          //alert( )
          notification.notice({
            content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>{`Désolé, le prix de votre commande doit atteindre au moins ${this.state.minimum_delivery.toFixed(2)} TND pour être livrer par Bistro73`}</span>, 
            duration: 5,
            onClose() {
              console.log('closable close');
            },
            closable: true,
          });

        }
      }
      else {
        //alert('champ(s) vide')
        notification.notice({
          content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>champ(s) vide </span>, 
          duration: 5,
          onClose() {
            console.log('closable close');
          },
          closable: true,
        });
      }
    }

  
  }

  handlechange(e) {
    let name = e.target.name
    let value = e.target.value
    var tel = this.state.phone
    var tableN = this.state.tableN

    if (name === "phone") {
      var v = value[tel.length]
      if (!isNaN(v) || v === "+" || v === undefined) {

      }
      else {
        value = tel
      }

    }
    if (name === "tableN") {
      var v = value[tableN.length]
      if (!isNaN(v) || v === undefined) {

      }
      else {
        value = tableN
      }

    }

    this.setState({ [name]: value })

  }
  saveorders() {
    let currency = this.props.currency
    let store_id = this.props.idRestaurant
    let store_name = this.props.name
    let total_price = this.state.order.total_price
    let user_uid = this.state.order.user_uid
    let note = this.state.note

    var ref_orders = firebase.database().ref(`/orders/${this.props.idRestaurant}/`)
    var ref_users_orders = firebase.database().ref(`/users_orders/${user_uid}/`)
    var ref_cart = firebase.database().ref(`/users_carts/${user_uid}/${this.props.idRestaurant}`)

    ref_users_orders.push({
      created_at: firebase.database.ServerValue.TIMESTAMP,
      currency: currency,
      store_id: store_id,
      store_name: store_name,
      total_price: total_price
    }).then((data) => {
      var key = data.key
      ref_orders.update(
        { [key]: { ...this.state.order, note: (this.state.note) ? this.state.note : null, created_at: firebase.database.ServerValue.TIMESTAMP, updated_at: firebase.database.ServerValue.TIMESTAMP 
          ,app_name: "BISTRO73",
          app_version: "1.0",
          platform: "web"} }
      ).then(() => {
        ref_cart.remove();
        this.setState({selected:0,
      etat:0,
      show:false,
      address: "sousse",
      position: "",
      updated_product:[],
      enabled_product:[],
      name:"",
      phone:"",
      tableN:"",
      order:"",
      showconfirm:false,
      note:"",
      zones:[],
      pos_restaut:[],
      current_pos:{lat:35.821432200973064,lng:10.598030090332031 },
      fee:null,
      delivered_by:null,
      adressa:"",
      reduce:0,
      new_total:0
})
      })

    })

  }
  saveorders_transaction()
   {
    var functions = firebase.functions();
    this.setState({loading:true})
    var validateLoyaltyTransaction = firebase.functions().httpsCallable('validateLoyaltyTransaction');
    
    
    let currency = this.props.currency
    let store_id = this.props.idRestaurant
    let store_name = this.props.name
    let total_price = this.state.new_total
    let user_uid = this.state.order.user_uid
    let note = this.state.note
    var type="money_spent"
    var ref_orders = firebase.database().ref(`/orders/${this.props.idRestaurant}/`)
    var ref_users_orders = firebase.database().ref(`/users_orders/${user_uid}/`)
    var ref_cart = firebase.database().ref(`/users_carts/${user_uid}/${this.props.idRestaurant}`)
    var ref_loyalty= firebase.database().ref(`/loyalty_points/${this.state.points.key}`);
    var ref_transaction= firebase.database().ref(`/transactions/`);

    var key= ref_users_orders.push().key
    validateLoyaltyTransaction({balance_used: this.state.reduce,transaction:{
    money_amount:this.state.reduce,store_id:store_id,type:type,user_uid:user_uid,order_id:key
      },points_id:this.state.points.key}).then((result)=> {
      // Read result of the Cloud Function.
     // var sanitizedMessage = result.data.text;
      // ...

     if(result.data){
      ref_users_orders.update({[key]:{
        created_at: firebase.database.ServerValue.TIMESTAMP,
        currency: currency,
        store_id: store_id,
        store_name: store_name,
       
        total_price: this.state.order.total_price,
        paid_with_loyalty:this.state.reduce
        }}).then(() => {
      
        
        ref_orders.update(
          { [key]: { ...this.state.order, note: (this.state.note) ? this.state.note : null,
            paid_with_loyalty:this.state.reduce,
            created_at: firebase.database.ServerValue.TIMESTAMP,
            updated_at: firebase.database.ServerValue.TIMESTAMP,
            app_name: "BISTRO73",
            app_version: "1.0",
            platform: "web" } }
        ).then(() => {
          ref_cart.remove();
        this.setState({selected:0,
        etat:0,
        show:false,
        address: "sousse",
        position: "",
        updated_product:[],
        enabled_product:[],
        name:"",
        phone:"",
        tableN:"",
        order:"",
        showconfirm:false,
        note:"",
        zones:[],
        pos_restaut:[],
        current_pos:{lat:35.821432200973064,lng:10.598030090332031 },
        fee:null,
        delivered_by:null,
        adressa:"",
        reduce:0,
        new_total:0,
        loading:false
    })
        })
    
      
    
    })
     }
     else{
      notification.notice({
        content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>Solde fidélité insuffisant</span>, 
        duration: 5,
        onClose() {
          console.log('closable close');
        },
        closable: true,
      });
      this.setState({selected:0,
        etat:0,
        show:false,
        address: "sousse",
        position: "",
        updated_product:[],
        enabled_product:[],
        name:"",
        phone:"",
        tableN:"",
        order:"",
        showconfirm:false,
        note:"",
        zones:[],
        pos_restaut:[],
        current_pos:{lat:35.821432200973064,lng:10.598030090332031 },
        fee:null,
        delivered_by:null,
        adressa:"",
        reduce:0,
        new_total:0,
        loading:false
    })

     }



    });
    /*if(this.state.points.balance>=this.state.reduce){
    ref_loyalty.update({balance:this.state.points.balance-this.state.reduce}).then(()=>{
    ref_users_orders.push({
    created_at: firebase.database.ServerValue.TIMESTAMP,
    currency: currency,
    store_id: store_id,
    store_name: store_name,
   
    total_price: this.state.order.total_price,
    paid_with_loyalty:this.state.reduce
    }).then((data) => {
    var key = data.key
    ref_transaction.push({created_at:firebase.database.ServerValue.TIMESTAMP,
    money_amount:this.state.reduce,store_id:store_id,type:type,user_uid:user_uid,order_id:key})

    ref_orders.update(
      { [key]: { ...this.state.order, note: (this.state.note) ? this.state.note : null,
        paid_with_loyalty:this.state.reduce,
        created_at: firebase.database.ServerValue.TIMESTAMP,
        updated_at: firebase.database.ServerValue.TIMESTAMP,
        app_name: "BISTRO73",
        app_version: "1.0",
        platform: "web" } }
    ).then(() => {
      ref_cart.remove();
    this.setState({selected:0,
    etat:0,
    show:false,
    address: "sousse",
    position: "",
    updated_product:[],
    enabled_product:[],
    name:"",
    phone:"",
    tableN:"",
    order:"",
    showconfirm:false,
    note:"",
    zones:[],
    pos_restaut:[],
    current_pos:{lat:35.821432200973064,lng:10.598030090332031 },
    fee:null,
    delivered_by:null,
    adressa:"",
    reduce:0,
    new_total:0
})
    })

  })

})

  }
  else{
    //alert("invalide transaction nous allons rafraîchir le page")
    notification.notice({
      content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>invalide transaction nous allons rafraîchir le page</span>, 
      duration: 5,
      onClose() {
        console.log('closable close');
      },
      closable: true,
    });

    window.location.reload()
  }*/
  }

  is_at_zone(e) {
    let zones = this.state.zones
    var prof = Object
      .keys(zones || [])
      .sort((a, b) => {
        if (zones[b].distance_limit > zones[a].distance_limit) {
          return -1;
        }
        if (zones[b].distance_limit < zones[a].distance_limit) {
          return 1;
        }// 
        return 0;
      })
      .reduce((_sortedObj, key) => ([
        ..._sortedObj,
        zones[key]
      ]), [])
    let result = false
    if (zones !== null) {
      Object.keys(prof || []).forEach((v, s) => {
        if ((e/1000 )<= parseInt(prof[v].distance_limit) && prof[v].is_zone_enabled&&result===false) {
          result = true
        this.props.cart.total_price
let fee=prof[v].fee
if(prof[v].minimum_price_for_free_delivery<= this.props.cart.total_price)
fee=0
if(prof[v].minimum_delivery_price<= this.props.cart.total_price)
          this.setState({fee:fee,delivered_by:prof[v].delivered_by,adressa:this.state.address,show:false,can_be_delivred:true})
          else
          this.setState({fee:fee,delivered_by:prof[v].delivered_by,adressa:this.state.address,show:false,can_be_delivred:false,minimum_delivery:prof[v].minimum_delivery_price})

        }
      })
    }
    return result
  }
  

  render (){
  console.log(   this.state)
  var max=((this.props.cart.total_price*100)<this.state.points.balance*100)?this.props.cart.total_price*100:this.state.points.balance*100
    var updated_product
    updated_product= this.state.updated_product
    var enabled_product=this.state.enabled_product
    var listOrders
    var notvide

    notvide=this.props.cart.items?true:false
    listOrders = this.props.cart.items ? Object.entries(this.props.cart.items).map((order, index) =>
  <div>    <Order updated_product={updated_product} enabled_product={enabled_product} order={order} key={index} currency={this.props.currency} idRestaurant={this.props.idRestaurant} />     <hr/>

    </div>) :<div><div style={{fontSize:"7em",margin:"20px 35% 20px 35%", color:"Tomato"}}> <i class="fa fa-shopping-bag fa-x3"></i> </div><h2 style={{marginLeft:20}}>Commancer votre Commande</h2></div>;
   // console.log(this.props.cart.items)
    return (
      <div className="sidebar-wrap" style={{    borderLeft: "1px solid #ffad18",
        borderRight: "1px solid #ffad18",
        borderTop: "1px solid #ffad18",
        borderBottom: "1px solid #ffad18"}}>

        <div className="widget widget-cart">
          <div className="widget-heading">
            <h3 className="widget-title text-dark">Votre panier</h3>
            <div className="clearfix">

            </div>
          </div>

{(this.state.etat === 4) ?      <div   class="col-xs-12">
<div style={{fontSize:40,color:"#ffffff", marginTop:20}} className="col-xs-12 ">
<center>  
  <h4> Votre Bonus Total:  {(this.state.points.balance)?(this.state.points.balance-(this.state.money_loyalty/100)).toFixed(3):0}   TND</h4>
<div class="slidecontainer">
<hr/>
<h1> {this.state.money_loyalty/100} TND</h1>
<hr/>
  <input type="range" min={this.state.programme.minimum_to_use*100} max={max} value={this.state.money_loyalty } class="slider"  id="myRange" onChange={(e)=>{
    console.log(this.state.programme.minimum_to_use)
    if(parseInt(e.target.value)>=this.state.programme.minimum_to_use)
    this.setState({money_loyalty: parseInt(e.target.value)})}

} />
 <div> 
 <hr/>
 <h4> Prix après réduction:  {(this.props.cart.total_price)?(this.props.cart.total_price-(this.state.money_loyalty/100)).toFixed(3):0}   TND</h4>

   <hr/>
   <button className="btn" style={{width:"40%", margin: '10px 5% 10px 5%',backgroundColor:"#000000",color:"#ffffff"}}
    onClick={() => { this.setState({ etat: 1,reduce:0,new_total:this.props.cart.total_price }) }}  type="button" >IGNORER</button> 
 <button className="btn" style={{width:"40%", margin: '10px 3% 10px  5%',backgroundColor:"#000000",color:"#ffffff"}}
  onClick={() => {this.setState({ etat: 1,reduce:this.state.money_loyalty/100,new_total:this.props.cart.total_price-(this.state.money_loyalty/100) })    }} type="button" >SUIVANT</button> </div> : <div />
        
</div>

</center>

</div>


</div>:<div/>}
          {(this.state.etat === 0) ? listOrders : <div />}
          <div className="widget-delivery clearfix">

          </div>
          <div className="widget-body">


            {(this.state.etat === 1) ? <div className="row" style={{marginLeft:10,marginRight:10,marginTop:10}} >
            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4" >
              <button style={{width: "100%"}}  disabled={!(this.state.services.togo&& this.state.permissions.togo)} style={{ color: "#ffffff", backgroundColor: (this.state.selected === 1) ? "#3b5998" : "#989a9e" }} onClick={() => { this.setState({ selected: 1 }) }} bsSize="large" block ><img style={{ float: 'left' }} height={25} width={25} src={ (this.state.selected === 1) ?img1:img4} />
              {(!(this.state.services.togo&& this.state.permissions.togo))? <i class="fa fa-ban " style={{color:"Tomato",fontSize:25}}></i>:<div/>} à_Emporter</button> 
              </div>
              
             {/*  <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4" >
              <button style={{width: "100%"}}  disabled={!(this.state.services.in_store&& this.state.permissions.in_store)}   style={{ color: "#ffffff", backgroundColor: (this.state.selected === 2) ? "#3b5998" : "#989a9e" }} onClick={() => { this.setState({ selected: 2 }) }} bsSize="large" block><img style={{ float: 'left' }} height={25} width={25} src={ (this.state.selected === 2) ?img2:img5} /> {(!(this.state.services.in_store&& this.state.permissions.in_store))? <i class="fa fa-ban " style={{color:"Tomato",fontSize:25}}></i>:<div/>} Sur_Place</button> 
    </div>*/}
              
              <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4" >
              <button style={{width: "100%"}}  disabled={!(this.state.services.delivery&& this.state.permissions.delivery)}  style={{ color: "#ffffff", backgroundColor: (this.state.selected === 3) ? "#3b5998" : "#989a9e" }} onClick={() => { this.setState({ selected: 3 }) }} bsSize="large" block><img style={{ float: 'left' }} height={25} width={35} src={ (this.state.selected === 3) ?img3:img6} /> 
              {(!(this.state.services.delivery&& this.state.permissions.delivery))? <i class="fa fa-ban " style={{color:"Tomato",fontSize:20}}></i>:<div/>} Livraison</button> 
              </div></div> : <div />}

            {(this.state.etat === 1) ? <div  style={{marginLeft:10,marginRight:10}} >
              <br />
              <FormGroup
                id="formBasicText"
              >
                <ControlLabel>Nom</ControlLabel>
                <FormControl
                  id="formControlsText"
                  type="text"
                  name="name"
                  placeholder="Nom"
                  onChange={(e) => {
                    this.handlechange(e)
                  }}
                />
              </FormGroup>
              <FormGroup
                id="formBasicText2"

              >
                <ControlLabel>Téléphone</ControlLabel>
                <FormControl
                  id="formControlsText2"
                  type="text"
                  name="phone"
                  value={this.state.phone}
                  placeholder="Téléphone"
                  onChange={(e) => {
                    this.handlechange(e)
                  }}
                />
              </FormGroup>
            </div> : <div />}

            {(this.state.selected === 2) ? <div>
              <FormGroup
                id="formBasicText3"
                style={{marginLeft:10,marginRight:10}}
              >
                <ControlLabel>Numéro de table</ControlLabel>
                <FormControl
                  id="formControlsText3"
                  type="text"
                  value={this.state.tableN}
                  name="tableN"
                  placeholder="Numéro de table"
                  onChange={(e) => {
                    this.handlechange(e)
                  }}
                />
              </FormGroup></div> : <div />}
            {(this.state.selected === 3 && this.state.etat===1) ? <div>
              <FormGroup
                id="formBasicText4"
                style={{marginLeft:20,marginRight:20}}
              >
                <a onClick={() => { this.handleShow() }}  style={{cursor:"pointer"}}> <h4>{(this.state.adressa)?this.state.adressa:"Indiquez un emplacement de livraison"} <img style={{}} height={25} width={25} src={maps} /></h4></a>
              </FormGroup></div> : <div />}
            <div className="price-wrap text-xs-center">
              {(this.state.etat === 1) ? <hr /> : <div />}
              {(this.state.etat === 0 &&notvide) ? <span style={{ marginLeft:20,marginRight:20,fontSize:20, color: "#000000", backgroundColor: "gray" }} ><span  style={{ float: 'left',marginLeft:10 }}>{this.props.cart.products_count} plat(s)  
               </span>  <span style={{ float: 'right' ,marginRight:10}}>{(this.props.cart.total_price)?this.props.cart.total_price.toFixed(3):""} {this.props.currency}  </span></span>: <div />}
               {(this.state.selected === 3 && this.state.fee>=0 && this.state.etat===1 &&this.state.can_be_delivred ) ? <h5 style={{fontFamily:"Roboto", marginLeft:20,marginRight:20,color: "gray", backgroundColor: "gray" }} ><span style={{ float: 'left' }}>Frais de Livraison 
               </span>  <span style={{ float: 'right' }}>{this.state.fee}{this.props.currency}   </span></h5>: <div />}
               {(this.state.etat === 0) ?   <br />:<p/>}
              {(this.state.etat === 0) ? <hr />:<p/>}
             { (this.state.selected === 3 && this.state.fee>0 && this.state.etat===1&&(!this.state.can_be_delivred))?<center><h4 style={{color:"red"}}> Désolé, le prix de votre commande doit atteindre au moins {this.state.minimum_delivery.toFixed(2)} TND pour être livrer par Bistro73 </h4></center>:null
}
                      {(this.state.selected === 3 && this.state.fee>=0&& this.state.etat===1&&this.state.can_be_delivred) ?   <br />:<p/>}
              {(this.state.selected === 3 && this.state.fee>0&& this.state.etat===1&&this.state.can_be_delivred) ? <hr />:<p/>}

           {(this.state.selected === 3 && this.state.fee>=0 && this.state.etat===1&&this.state.can_be_delivred) ? <h5  style={{fontFamily:"Roboto", marginLeft:20,marginRight:20, color: "gray", backgroundColor: "gray" }} ><span style={{ float: 'left' }}>Prix total
               </span>  <span style={{ float: 'right' }}>{this.state.fee+this.props.cart.total_price-this.state.reduce}{this.props.currency}   </span></h5>: <div />}

               {(this.state.selected === 1 &&  this.state.etat===1) ? <h5  style={{fontFamily:"Roboto", marginLeft:20,marginRight:20, color: "gray", backgroundColor: "gray" }} ><span style={{ float: 'left' }}>Prix total
               </span>  <span style={{ float: 'right' }}>{this.props.cart.total_price-this.state.reduce}{this.props.currency}   </span></h5>: <div />}
          {(this.state.selected === 3 && this.state.fee>=0&& this.state.etat===1&&this.state.can_be_delivred) ?   <br />:<p/>}
              {(this.state.selected === 3 && this.state.fee>=0&& this.state.etat===1&&this.state.can_be_delivred) ? <hr />:<p/>}

               {(this.state.selected === 1 &&  this.state.etat===1) ?   <br />:<p/>}
              {(this.state.selected === 1 &&  this.state.etat===1) ? <hr />:<p/>}

              {(this.state.etat === 0&& notvide) ? <button style={{width:"60%", margin: '10px 20% 10px  20%',backgroundColor:"#ffad18",color:"#ffffff"}} type="button" className="btn" onClick={() => {
              if(this.props.open===true){

if(this.state.points.balance>=this.state.programme.minimum_to_use &&(this.props.cart.total_price>= this.state.programme.minimum_to_use) ){
  this.setState({ etat:4 })
}
else{
  this.setState({ etat:1 })
}                            
              }   
                else{
                 // alert("restaurant ferme")
                  notification.notice({
                    content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>restaurant fermé</span>, 
                    duration: 5,
                    onClose() {
                      console.log('closable close');
                    },
                    closable: true,
                  });
              
                  console.log(this.props.open)
                }
              
              }}>suivant</button> : <div />}
              {(this.state.etat === 1) ? <div> <button className="btn" style={{width:"20%", margin: '10px 10% 10px 10%',backgroundColor:"#ffad18",color:"#ffffff"}} onClick={() => { this.setState({ etat: 0 }) }}  type="button" >Retour</button> <button className="btn" style={{width:"45%", margin: '10px 3% 10px  10%',backgroundColor:"#ffad18",color:"#ffffff"}} onClick={() => { this.passer_commande() }} type="button" >Commander</button> </div> : <div />}
            </div>
          </div>
        </div>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Sélectionner unne adresse à proximité</Modal.Title>
          </Modal.Header>
          <Modal.Body>
      {  (this.state.alert_out_zone)?  <Alert bsStyle="danger" >
          <h4>Désolé, la dernière position sélectionnée est en dehors de la zone de livraison </h4>
          
        </Alert>:<div/>}
            <MapUserLocation
              containerElement={<div style={{ height: '100%' }} />}
              mapElement={<div style={{ height: '400px' }} />}
              googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyC9z2ExBdH_ALjzifswDY5HY9sQZ5qM3Mw&language=fr&region=FR"
              loadingElement={<div style={{ height: `50%` }} />}
            >
              <Marker
                position={{ lat: this.state.current_pos.lat, lng: this.state.current_pos.lng }}
                draggable={true}
                onDragEnd={(e) => {
                  var geocoder = new google.maps.Geocoder
                  var latlng = { lat: parseFloat(e.latLng.lat()), lng: parseFloat(e.latLng.lng()) };
                  this.setState({ current_pos: latlng })
                  geocoder.geocode({ 'location': latlng }, (results, status) => {
                    if (status === 'OK') {
                      if (results[0]) {
                        if (results[0].formatted_address.indexOf("Unnamed Road") === 0) {
                         // console.log("Unnamed Road, " + results[1].formatted_address)
                          this.setState({ address: "Unnamed Road, " + results[1].formatted_address })
                        }
                        else {
                          this.setState({ address: results[0].formatted_address })
                        }
                       // console.log(results[0].formatted_address)
                      } else {
                        console.log('No results found');
                      }
                    } else {
                      console.log('Geocoder failed due to: ' + status);
                    }
                  });
                }}
              />
            </MapUserLocation>
            <h4 style={{ textAlign: "center", backgroundColor: 'grey', color: "#ffffff" }}><img style={{ marginRight: 10 }} src={maps} />{this.state.address}</h4>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="warning" onClick={this.handleClose}>Cancel</Button>
            <Button bsStyle="primary" onClick={() => this.calcul_distance()}>Sélectionner cette position</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.showconfirm} onHide={() => this.setState({ showconfirm: false, order: "" })}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmer l'envoi de la commande</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormControl componentClass="textarea"
              name="note"
              onChange={(e) => this.handlechange(e)}
              placeholder="Ajouter une remarque pour le restaurant ou le livreur" />
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="warning" style={{ marginRight: 10 }} onClick={() => this.setState({ showconfirm: false, order: "" })}>ANNULER</Button>
            <Button bsStyle="primary" onClick={() => {
               if(this.state.reduce>0)
               {
                 this.saveorders_transaction()

               }
               else{
                this.saveorders()

               }
               
                }}>{(this.state.loading)? <ReactLoading height={20} width={20}	 type="spin" />:<span>OUI </span>}</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default Cart;



// WEBPACK FOOTER //
// ./src/container/Cart.js